import { baseApi } from "./baseApi";

const ANNOUNCEMENT_BASE_URL = "/announcements";

export const announcementApi = baseApi.injectEndpoints({
  tagTypes: ["Announcement"],

  endpoints: (builder) => ({
    getAnnouncementList: builder.query({
      query: (params) => ({
        url: `${ANNOUNCEMENT_BASE_URL}/announcement-list`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result?.data.map(({ _id }) => ({ type: "Announcement", _id })),
              { type: "Announcement", id: "LIST" },
            ]
          : [{ type: "Announcement", id: "LIST" }],
    }),

    getAnnouncementDetail: builder.query({
      query: (id) => `${ANNOUNCEMENT_BASE_URL}/announcement-edit/${id}`,
      providesTags: (result, error, id) => [
        { type: "Announcement", id },
        { type: "Announcement", id: "LIST" },
      ],
    }),

    createAnnouncement: builder.mutation({
      query: (payload) => ({
        url: `${ANNOUNCEMENT_BASE_URL}/announcement-create`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "Announcement", id: "LIST" },
      ],
    }),

    updateAnnouncement: builder.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;

        return {
          url: `${ANNOUNCEMENT_BASE_URL}/announcement-edit/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Announcement", _id },
        { type: "Announcement", id: "LIST" },
      ],
    }),
    addReactionToAnnouncement: builder.mutation({
      query: ({ id, ...payload }) => ({
        url: `${ANNOUNCEMENT_BASE_URL}/${id}/react`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error) => [
        { type: "Announcement", id: "LIST" },
      ],
    }),
    // announcement responses
    addAnnouncementResponse: builder.mutation({
      query: (payload) => {
        const { announcementId, ...body } = payload;

        return {
          url: `${ANNOUNCEMENT_BASE_URL}/${announcementId}/responses`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Announcement", id: _id },
        { type: "Announcement", id: "LIST" },
      ],
    }),

    updateAnnouncementResponse: builder.mutation({
      query: (payload) => {
        const { announcementId, ...body } = payload;

        return {
          url: `${ANNOUNCEMENT_BASE_URL}/${announcementId}/responses`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Announcement", id: _id },
        { type: "Announcement", id: "LIST" },
      ],
    }),
    addReactionToResponse: builder.mutation({
      query: ({ id, responseId, ...payload }) => ({
        url: `${ANNOUNCEMENT_BASE_URL}/${id}/${responseId}/react`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { responseId }) => [
        { type: "Response", id: responseId },
        { type: "Announcement", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetAnnouncementListQuery,
  useLazyGetAnnouncementListQuery,
  useAddReactionToAnnouncementMutation,
  useGetAnnouncementDetailQuery,
  useCreateAnnouncementMutation,
  useUpdateAnnouncementMutation,
  useAddAnnouncementResponseMutation,
  useUpdateAnnouncementResponseMutation,
  useAddReactionToResponseMutation,
} = announcementApi;
